<style lang="less">
.k-pagination .van-pagination__item,
.k-pagination .van-pagination__page-desc {
   height: .8rem;
   line-height: .8rem;
   font-size: .24rem;
}
.k-pagination .van-pagination__item {
   color: #C1272D;
}
.k-pagination .van-pagination__item--disabled, 
.k-pagination .van-pagination__item--disabled:active {
    color: #666;
}
</style>

<template>
    <div class="k-pagination">
        <van-pagination v-model="curPage" :page-count="count" mode="simple" @change="change" />
    </div>
</template>

<script>
    export default {
        name: 'k-pagination',
        data() {
            return {
                curPage: 1
            }
        },
        props: ['page', 'count'],
        methods: {
            change(e) {
                this.$emit("change", e)
            }
        },
        watch: {
            page(curPage) {
                if (curPage > 0) {
                    this.curPage = +curPage
                }
            }
        },
        created() {
            this.curPage = +this.page
        }
    };

</script>
